// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ════════════════════════════════════════════════════════════════════════
   Forms

   Single column, full-width fields, labels above. Every text field is at
   least 48px tall and carries a 16px font — under 16px, iOS Safari zooms
   the viewport on focus and never zooms back, which is the single most
   common way a web form betrays itself as a web form.
   ════════════════════════════════════════════════════════════════════════ */

/* Two-column form rows collapse — a 390px screen has no second column. */
html.m-app .form-row,
html.m-app .form-grid,
html.m-app .co-field-row {
  display: flex;
  flex-direction: column;
  gap: var(--m-3);
}

html.m-app .form-group {
  display: flex;
  flex-direction: column;
  gap: var(--m-2);
  margin-bottom: var(--m-4);
  width: 100%;
}

html.m-app .form-group label,
html.m-app .co-field-label,
html.m-app .filter-label,
html.m-app .m-label {
  font-size: var(--m-fs-label);
  font-weight: var(--m-fw-medium);
  line-height: 1.3;
  letter-spacing: 0.01em;
  color: var(--color-text-secondary);
  margin: 0;
}

html.m-app .field-optional {
  font-size: var(--m-fs-caption);
  font-weight: var(--m-fw-regular);
  color: var(--color-text-muted);
}

/* ── Text fields ────────────────────────────────────────────────────────── */
html.m-app input[type="text"],
html.m-app input[type="email"],
html.m-app input[type="password"],
html.m-app input[type="tel"],
html.m-app input[type="number"],
html.m-app input[type="search"],
html.m-app input[type="url"],
html.m-app input[type="date"],
html.m-app input[type="datetime-local"],
html.m-app select,
html.m-app textarea {
  width: 100%;
  min-height: var(--m-control);
  padding: 0 var(--m-3);
  border: 1px solid var(--m-hairline-strong);
  border-radius: var(--m-r-sm);
  background: var(--m-surface-card);
  color: var(--color-text-primary);
  /* 16px — see header note on iOS zoom. */
  font-size: 1rem;
  line-height: var(--m-lh-body);
  font-family: var(--font-sans);
  appearance: none;
  -webkit-appearance: none;
  transition: border-color var(--m-dur-fast) var(--m-ease),
              box-shadow var(--m-dur-fast) var(--m-ease);
}

html.m-app textarea {
  min-height: 96px;
  padding: var(--m-3);
  line-height: var(--m-lh-body);
  resize: vertical;
}

html.m-app input::placeholder,
html.m-app textarea::placeholder {
  color: var(--color-text-muted);
  font-size: var(--m-fs-body);
}

html.m-app input:focus,
html.m-app select:focus,
html.m-app textarea:focus {
  outline: none;
  border-color: var(--color-secondary);
  box-shadow: 0 0 0 3px var(--color-focus-ring);
}

html.m-app input:disabled,
html.m-app select:disabled,
html.m-app textarea:disabled {
  background: var(--m-surface-sunken);
  color: var(--color-text-muted);
}

/* ── Icon-prefixed fields ───────────────────────────────────────────────
   A recurring pattern in this app: a wrapper holds the border, background
   and a leading icon, and the <input> inside is deliberately bare. The
   generic input rule above would give that input a second border and fill,
   producing a field nested inside a field — which is what the profile form
   and the orders search both looked like.

   So the wrapper becomes the field, and the input inside it is stripped
   back to transparent. Both halves are needed: styling only the wrapper
   would leave the input's default chrome showing. */
html.m-app :is(
  .pf-input-wrap,
  .pw-input-wrap,
  .cpn-input-wrap,
  .dagent-input-wrap,
  .admin-modal-input-wrap,
  .ftr-subscribe-input-wrap,
  .ntf-search-wrap,
  .sl-search-wrap,
  .input-with-icon
) {
  display: flex;
  align-items: center;
  gap: var(--m-2);
  width: 100%;
  min-height: var(--m-control);
  padding: 0 var(--m-3);
  border: 1px solid var(--m-hairline-strong);
  border-radius: var(--m-r-sm);
  background: var(--m-surface-card);
}

html.m-app :is(
  .pf-input-wrap,
  .pw-input-wrap,
  .cpn-input-wrap,
  .dagent-input-wrap,
  .admin-modal-input-wrap,
  .ftr-subscribe-input-wrap,
  .ntf-search-wrap,
  .sl-search-wrap,
  .input-with-icon
):focus-within {
  border-color: var(--color-secondary);
  box-shadow: 0 0 0 3px var(--color-focus-ring);
}

html.m-app :is(
  .pf-input-wrap,
  .pw-input-wrap,
  .cpn-input-wrap,
  .dagent-input-wrap,
  .admin-modal-input-wrap,
  .ftr-subscribe-input-wrap,
  .ntf-search-wrap,
  .sl-search-wrap,
  .input-with-icon
) :is(input, textarea, select) {
  flex: 1 1 auto;
  min-width: 0;
  width: 100%;
  height: 100%;
  min-height: 0;
  padding: 0;
  border: none;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

html.m-app :is(
  .pf-input-wrap,
  .pw-input-wrap,
  .cpn-input-wrap,
  .dagent-input-wrap,
  .admin-modal-input-wrap,
  .ftr-subscribe-input-wrap,
  .ntf-search-wrap,
  .sl-search-wrap,
  .input-with-icon
) :is(input, textarea, select):focus {
  box-shadow: none;
}

/* The icon sits in the flex row rather than being absolutely positioned
   over a padded input. */
html.m-app :is(.pf-input-icon, .cpn-input-icon, .input-icon) {
  position: static;
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  color: var(--color-text-muted);
  pointer-events: none;
}

html.m-app :is(.pf-input-icon, .cpn-input-icon, .input-icon) svg {
  width: var(--m-icon-sm);
  height: var(--m-icon-sm);
}

/* A trailing control inside the field (the password eye) stays tappable. */
html.m-app :is(.pf-input-wrap, .pw-input-wrap) button {
  flex: 0 0 auto;
  width: 36px;
  height: 36px;
  min-width: 36px;
  min-height: 36px;
  padding: 0;
  border: none;
  background: transparent;
  color: var(--color-text-muted);
}

/* ── Select ─────────────────────────────────────────────────────────────
   A native <select> opens the platform picker (a wheel on iOS, a sheet on
   Android), which is exactly what's wanted — so the element stays native
   and only the closed state is restyled, with a drawn caret since
   appearance:none removes the UA one. */
html.m-app select {
  padding-right: var(--m-8);
  background-image:
    linear-gradient(45deg, transparent 50%, currentColor 50%),
    linear-gradient(135deg, currentColor 50%, transparent 50%);
  background-position:
    calc(100% - 18px) calc(50% + 2px),
    calc(100% - 13px) calc(50% + 2px);
  background-size: 5px 5px, 5px 5px;
  background-repeat: no-repeat;
  color: var(--color-text-primary);
}

/* ── Toggle switch ──────────────────────────────────────────────────────
   The account settings render a <label> wrapping a real checkbox plus a
   .setting-check box that draws the tick. A checkbox is the desktop idiom
   for a preference; on a phone an immediate on/off preference is a switch.

   The input stays in the DOM and stays operable — it's moved off-screen
   rather than display:none, so it keeps its accessible role, its label
   association and keyboard focus — and .setting-check is redrawn as a
   track with a sliding thumb.

   Meaning never rests on the colour of the track alone: the thumb position
   states it, which is legible without colour vision entirely. */
html.m-app .setting-item {
  align-items: center;
  gap: var(--m-3);
  padding: var(--m-3) 0;
  min-height: 60px;
  border-bottom: 1px solid var(--m-hairline);
}

html.m-app .settings-options > .setting-item:last-child {
  border-bottom: none;
}

html.m-app .setting-icon {
  width: 36px;
  height: 36px;
  min-width: 36px;
  border-radius: var(--m-r-sm);
  flex: 0 0 auto;
}

html.m-app .setting-icon svg {
  width: var(--m-icon); height: var(--m-icon);
}

html.m-app .setting-copy {
  flex: 1 1 auto;
  gap: 2px;
}

html.m-app .setting-copy strong {
  font-size: var(--m-fs-body);
  font-weight: var(--m-fw-medium);
  line-height: var(--m-lh-snug);
}

html.m-app .setting-copy small {
  font-size: var(--m-fs-secondary);
  line-height: var(--m-lh-snug);
  color: var(--color-text-secondary);
}

html.m-app .setting-item input[type="checkbox"] {
  position: absolute;
  width: 1px;
  height: 1px;
  min-height: 0;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  white-space: nowrap;
}

html.m-app .setting-check {
  position: relative;
  flex: 0 0 auto;
  width: 50px;
  height: 30px;
  min-width: 50px;
  padding: 0;
  border: none;
  border-radius: var(--m-r-pill);
  background: color-mix(in srgb, var(--color-brand-navy) 18%, transparent);
  transition: background-color var(--m-dur) var(--m-ease);
}

/* The tick icon inside is redundant once this is a switch. */
html.m-app .setting-check svg { display: none; }

html.m-app .setting-check::after {
  content: '';
  position: absolute;
  top: 3px;
  left: 3px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: var(--color-brand-white);
  box-shadow: 0 1px 3px rgba(1, 13, 33, 0.25);
  transition: transform var(--m-dur) var(--m-ease);
}

html.m-app .setting-item input:checked + .setting-check {
  background: var(--color-secondary);
  border-color: transparent;
}

html.m-app .setting-item input:checked + .setting-check::after {
  transform: translateX(20px);
}

html.m-app .setting-item input:focus-visible + .setting-check {
  box-shadow: 0 0 0 3px var(--color-focus-ring);
}

html.m-app[data-theme="dark"] .setting-check {
  background: rgba(255, 255, 255, 0.22);
}

/* ── Segmented control ──────────────────────────────────────────────────
   The theme picker is already a two-up button group, which is the right
   shape; it just needs mobile measure — and the selected segment needs
   navy on blue rather than white, which is 3.1:1 and fails AA. */
html.m-app .settings-theme-toggle,
html.m-app .m-segmented {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  gap: 2px;
  margin-top: var(--m-3);
  padding: 3px;
  border: none;
  border-radius: var(--m-r-sm);
  background: var(--m-surface-sunken);
  overflow: hidden;
}

html.m-app .settings-theme-toggle button,
html.m-app .m-segmented button {
  min-height: 38px;
  gap: var(--m-2);
  border: none;
  border-radius: calc(var(--m-r-sm) - 3px);
  background: transparent;
  color: var(--color-text-secondary);
  font-size: var(--m-fs-secondary);
  font-weight: var(--m-fw-medium);
  transition: background-color var(--m-dur-fast) var(--m-ease),
              color var(--m-dur-fast) var(--m-ease);
}

html.m-app .settings-theme-toggle button.active,
html.m-app .m-segmented button[aria-selected="true"],
html.m-app .m-segmented button.active {
  background: var(--m-surface-card);
  color: var(--color-text-primary);
  font-weight: var(--m-fw-semibold);
  box-shadow: var(--m-shadow-sm);
}

html.m-app .settings-theme-toggle button svg,
html.m-app .m-segmented button svg {
  width: var(--m-icon-sm); height: var(--m-icon-sm);
}

/* ── Radio / checkbox rows ──────────────────────────────────────────────
   Where a genuine multi-select or single-choice list exists (delivery
   options, filters), the whole row is the target, not the 20px control. */
html.m-app .m-choice-row,
html.m-app .sf-checkbox-row {
  display: flex;
  align-items: center;
  gap: var(--m-3);
  min-height: var(--m-touch);
  padding: var(--m-2) 0;
  font-size: var(--m-fs-body);
  cursor: pointer;
}

html.m-app input[type="checkbox"]:not(.setting-item input),
html.m-app input[type="radio"] {
  width: 22px;
  height: 22px;
  min-height: 22px;
  min-width: 22px;
  flex: 0 0 auto;
  accent-color: var(--color-secondary);
}

/* ── Quantity stepper ───────────────────────────────────────────────────
   Three targets in a row, each a full 44px, with a tabular numeral so the
   width doesn't jump between 9 and 10. */
html.m-app .qty-controls,
html.m-app .m-stepper {
  display: inline-flex;
  align-items: center;
  border: 1px solid var(--m-hairline-strong);
  border-radius: var(--m-r-sm);
  overflow: hidden;
  background: var(--m-surface-card);
}

html.m-app .qty-controls button,
html.m-app .m-stepper button {
  width: var(--m-touch);
  height: var(--m-touch);
  min-width: var(--m-touch);
  min-height: var(--m-touch);
  padding: 0;
  border: none;
  border-radius: 0;
  background: transparent;
  color: var(--color-text-primary);
  font-size: var(--m-fs-section);
}

html.m-app .qty-controls button:active,
html.m-app .m-stepper button:active {
  background: var(--color-surface-hover);
}

html.m-app .qty-controls > span,
html.m-app .m-stepper > span {
  min-width: 40px;
  text-align: center;
  font-size: var(--m-fs-body);
  font-weight: var(--m-fw-semibold);
  font-variant-numeric: tabular-nums;
}

/* ── Validation ─────────────────────────────────────────────────────────
   Error state carries a border, a tinted fill AND a message with an icon —
   orange alone can't distinguish error from warning in a four-colour
   system, so the text is what actually says which it is. */
html.m-app .form-group.has-error input,
html.m-app .form-group.has-error select,
html.m-app .form-group.has-error textarea,
html.m-app input[aria-invalid="true"] {
  border-color: var(--color-primary);
  background: var(--color-primary-soft);
}

html.m-app .field-error,
html.m-app .form-error {
  display: flex;
  align-items: flex-start;
  gap: var(--m-1);
  font-size: var(--m-fs-secondary);
  line-height: var(--m-lh-snug);
  color: var(--color-text-primary);
  margin: 0;
}

/* ── Password visibility toggle ─────────────────────────────────────────── */
html.m-app .pw-toggle,
html.m-app .password-toggle {
  width: var(--m-touch);
  height: var(--m-touch);
  min-width: var(--m-touch);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  color: var(--color-text-muted);
}

/* ── Cart quantity stepper ──────────────────────────────────────────────
   .cs-qty-btn is declared 42x38 but renders 23x44: it sits in a flex row
   (.cs-qty-group) that shrinks it, and 23px wide is well under the point
   where a thumb hits it reliably -- on the one control where a mis-tap
   changes what the customer is about to buy.

   Given the same treatment as the other steppers in this layer: a bordered
   group with square 44px targets that refuse to shrink, and a tabular
   numeral between them so the width does not jump between 9 and 10. */
html.m-app .cs-qty-group {
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
  border: 1px solid var(--m-hairline-strong);
  border-radius: var(--m-r-sm);
  overflow: hidden;
  background: var(--m-surface-card);
}

html.m-app .cs-qty-btn {
  flex: 0 0 auto;
  width: var(--m-touch);
  height: var(--m-touch);
  min-width: var(--m-touch);
  min-height: var(--m-touch);
  padding: 0;
  border: none;
  border-radius: 0;
  background: transparent;
  font-size: var(--m-fs-section);
  color: var(--color-text-primary);
}

html.m-app .cs-qty-btn:active:not(:disabled) {
  background: var(--color-surface-hover);
}

html.m-app .cs-qty {
  min-width: 36px;
  text-align: center;
  font-size: var(--m-fs-body);
  font-weight: var(--m-fw-semibold);
  font-variant-numeric: tabular-nums;
}
`, "",{"version":3,"sources":["webpack://./src/mobile/forms.css"],"names":[],"mappings":"AAAA;;;;;;;6EAO6E;;AAE7E,yEAAyE;AACzE;;;EAGE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;;AAEA;;;;EAIE,4BAA4B;EAC5B,+BAA+B;EAC/B,gBAAgB;EAChB,sBAAsB;EACtB,kCAAkC;EAClC,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA,8EAA8E;AAC9E;;;;;;;;;;;EAWE,WAAW;EACX,4BAA4B;EAC5B,qBAAqB;EACrB,0CAA0C;EAC1C,4BAA4B;EAC5B,iCAAiC;EACjC,gCAAgC;EAChC,wCAAwC;EACxC,eAAe;EACf,6BAA6B;EAC7B,6BAA6B;EAC7B,gBAAgB;EAChB,wBAAwB;EACxB;wDACsD;AACxD;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;;EAEE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;;;EAGE,aAAa;EACb,oCAAoC;EACpC,6CAA6C;AAC/C;;AAEA;;;EAGE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;;;;;;;;;oDASoD;AACpD;;;;;;;;;;;EAWE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,4BAA4B;EAC5B,qBAAqB;EACrB,0CAA0C;EAC1C,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;;;;;;;;;;;EAWE,oCAAoC;EACpC,6CAA6C;AAC/C;;AAEA;;;;;;;;;;;EAWE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;;;;;;;;;;EAWE,gBAAgB;AAClB;;AAEA;yBACyB;AACzB;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA,2EAA2E;AAC3E;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;;;;wCAIwC;AACxC;EACE,yBAAyB;EACzB;;8DAE4D;EAC5D;;qCAEmC;EACnC,iCAAiC;EACjC,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;;;;;;;;;;;gEAWgE;AAChE;EACE,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,oBAAoB,EAAE,qBAAqB;AAC7C;;AAEA;EACE,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,aAAa;EACb,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,UAAU;EACV,YAAY;EACZ,8BAA8B;EAC9B,wEAAwE;EACxE,uDAAuD;AACzD;;AAEA,6DAA6D;AAC7D,gCAAgC,aAAa,EAAE;;AAE/C;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,2CAA2C;EAC3C,gDAAgD;AAClD;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;;iEAGiE;AACjE;;EAEE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,wCAAwC;EACxC,uBAAuB;EACvB,kCAAkC;EAClC,gCAAgC;EAChC,+BAA+B;EAC/B;mDACiD;AACnD;;AAEA;;;EAGE,iCAAiC;EACjC,gCAAgC;EAChC,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;;EAEE,uBAAuB,EAAE,wBAAwB;AACnD;;AAEA;;0EAE0E;AAC1E;;EAEE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,qBAAqB;EACrB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,oCAAoC;AACtC;;AAEA;;yCAEyC;AACzC;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,0CAA0C;EAC1C,4BAA4B;EAC5B,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;;EAEE,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;EAC1B,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;;EAEE,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;;;2DAG2D;AAC3D;;;;EAIE,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,gCAAgC;EAChC,6BAA6B;EAC7B,gCAAgC;EAChC,SAAS;AACX;;AAEA,8EAA8E;AAC9E;;EAEE,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;;;;;;;;sEAQsE;AACtE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,0CAA0C;EAC1C,4BAA4B;EAC5B,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;EAC1B,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,iCAAiC;EACjC,kCAAkC;AACpC","sourcesContent":["/* ════════════════════════════════════════════════════════════════════════\n   Forms\n\n   Single column, full-width fields, labels above. Every text field is at\n   least 48px tall and carries a 16px font — under 16px, iOS Safari zooms\n   the viewport on focus and never zooms back, which is the single most\n   common way a web form betrays itself as a web form.\n   ════════════════════════════════════════════════════════════════════════ */\n\n/* Two-column form rows collapse — a 390px screen has no second column. */\nhtml.m-app .form-row,\nhtml.m-app .form-grid,\nhtml.m-app .co-field-row {\n  display: flex;\n  flex-direction: column;\n  gap: var(--m-3);\n}\n\nhtml.m-app .form-group {\n  display: flex;\n  flex-direction: column;\n  gap: var(--m-2);\n  margin-bottom: var(--m-4);\n  width: 100%;\n}\n\nhtml.m-app .form-group label,\nhtml.m-app .co-field-label,\nhtml.m-app .filter-label,\nhtml.m-app .m-label {\n  font-size: var(--m-fs-label);\n  font-weight: var(--m-fw-medium);\n  line-height: 1.3;\n  letter-spacing: 0.01em;\n  color: var(--color-text-secondary);\n  margin: 0;\n}\n\nhtml.m-app .field-optional {\n  font-size: var(--m-fs-caption);\n  font-weight: var(--m-fw-regular);\n  color: var(--color-text-muted);\n}\n\n/* ── Text fields ────────────────────────────────────────────────────────── */\nhtml.m-app input[type=\"text\"],\nhtml.m-app input[type=\"email\"],\nhtml.m-app input[type=\"password\"],\nhtml.m-app input[type=\"tel\"],\nhtml.m-app input[type=\"number\"],\nhtml.m-app input[type=\"search\"],\nhtml.m-app input[type=\"url\"],\nhtml.m-app input[type=\"date\"],\nhtml.m-app input[type=\"datetime-local\"],\nhtml.m-app select,\nhtml.m-app textarea {\n  width: 100%;\n  min-height: var(--m-control);\n  padding: 0 var(--m-3);\n  border: 1px solid var(--m-hairline-strong);\n  border-radius: var(--m-r-sm);\n  background: var(--m-surface-card);\n  color: var(--color-text-primary);\n  /* 16px — see header note on iOS zoom. */\n  font-size: 1rem;\n  line-height: var(--m-lh-body);\n  font-family: var(--font-sans);\n  appearance: none;\n  -webkit-appearance: none;\n  transition: border-color var(--m-dur-fast) var(--m-ease),\n              box-shadow var(--m-dur-fast) var(--m-ease);\n}\n\nhtml.m-app textarea {\n  min-height: 96px;\n  padding: var(--m-3);\n  line-height: var(--m-lh-body);\n  resize: vertical;\n}\n\nhtml.m-app input::placeholder,\nhtml.m-app textarea::placeholder {\n  color: var(--color-text-muted);\n  font-size: var(--m-fs-body);\n}\n\nhtml.m-app input:focus,\nhtml.m-app select:focus,\nhtml.m-app textarea:focus {\n  outline: none;\n  border-color: var(--color-secondary);\n  box-shadow: 0 0 0 3px var(--color-focus-ring);\n}\n\nhtml.m-app input:disabled,\nhtml.m-app select:disabled,\nhtml.m-app textarea:disabled {\n  background: var(--m-surface-sunken);\n  color: var(--color-text-muted);\n}\n\n/* ── Icon-prefixed fields ───────────────────────────────────────────────\n   A recurring pattern in this app: a wrapper holds the border, background\n   and a leading icon, and the <input> inside is deliberately bare. The\n   generic input rule above would give that input a second border and fill,\n   producing a field nested inside a field — which is what the profile form\n   and the orders search both looked like.\n\n   So the wrapper becomes the field, and the input inside it is stripped\n   back to transparent. Both halves are needed: styling only the wrapper\n   would leave the input's default chrome showing. */\nhtml.m-app :is(\n  .pf-input-wrap,\n  .pw-input-wrap,\n  .cpn-input-wrap,\n  .dagent-input-wrap,\n  .admin-modal-input-wrap,\n  .ftr-subscribe-input-wrap,\n  .ntf-search-wrap,\n  .sl-search-wrap,\n  .input-with-icon\n) {\n  display: flex;\n  align-items: center;\n  gap: var(--m-2);\n  width: 100%;\n  min-height: var(--m-control);\n  padding: 0 var(--m-3);\n  border: 1px solid var(--m-hairline-strong);\n  border-radius: var(--m-r-sm);\n  background: var(--m-surface-card);\n}\n\nhtml.m-app :is(\n  .pf-input-wrap,\n  .pw-input-wrap,\n  .cpn-input-wrap,\n  .dagent-input-wrap,\n  .admin-modal-input-wrap,\n  .ftr-subscribe-input-wrap,\n  .ntf-search-wrap,\n  .sl-search-wrap,\n  .input-with-icon\n):focus-within {\n  border-color: var(--color-secondary);\n  box-shadow: 0 0 0 3px var(--color-focus-ring);\n}\n\nhtml.m-app :is(\n  .pf-input-wrap,\n  .pw-input-wrap,\n  .cpn-input-wrap,\n  .dagent-input-wrap,\n  .admin-modal-input-wrap,\n  .ftr-subscribe-input-wrap,\n  .ntf-search-wrap,\n  .sl-search-wrap,\n  .input-with-icon\n) :is(input, textarea, select) {\n  flex: 1 1 auto;\n  min-width: 0;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  padding: 0;\n  border: none;\n  border-radius: 0;\n  background: transparent;\n  box-shadow: none;\n}\n\nhtml.m-app :is(\n  .pf-input-wrap,\n  .pw-input-wrap,\n  .cpn-input-wrap,\n  .dagent-input-wrap,\n  .admin-modal-input-wrap,\n  .ftr-subscribe-input-wrap,\n  .ntf-search-wrap,\n  .sl-search-wrap,\n  .input-with-icon\n) :is(input, textarea, select):focus {\n  box-shadow: none;\n}\n\n/* The icon sits in the flex row rather than being absolutely positioned\n   over a padded input. */\nhtml.m-app :is(.pf-input-icon, .cpn-input-icon, .input-icon) {\n  position: static;\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  color: var(--color-text-muted);\n  pointer-events: none;\n}\n\nhtml.m-app :is(.pf-input-icon, .cpn-input-icon, .input-icon) svg {\n  width: var(--m-icon-sm);\n  height: var(--m-icon-sm);\n}\n\n/* A trailing control inside the field (the password eye) stays tappable. */\nhtml.m-app :is(.pf-input-wrap, .pw-input-wrap) button {\n  flex: 0 0 auto;\n  width: 36px;\n  height: 36px;\n  min-width: 36px;\n  min-height: 36px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  color: var(--color-text-muted);\n}\n\n/* ── Select ─────────────────────────────────────────────────────────────\n   A native <select> opens the platform picker (a wheel on iOS, a sheet on\n   Android), which is exactly what's wanted — so the element stays native\n   and only the closed state is restyled, with a drawn caret since\n   appearance:none removes the UA one. */\nhtml.m-app select {\n  padding-right: var(--m-8);\n  background-image:\n    linear-gradient(45deg, transparent 50%, currentColor 50%),\n    linear-gradient(135deg, currentColor 50%, transparent 50%);\n  background-position:\n    calc(100% - 18px) calc(50% + 2px),\n    calc(100% - 13px) calc(50% + 2px);\n  background-size: 5px 5px, 5px 5px;\n  background-repeat: no-repeat;\n  color: var(--color-text-primary);\n}\n\n/* ── Toggle switch ──────────────────────────────────────────────────────\n   The account settings render a <label> wrapping a real checkbox plus a\n   .setting-check box that draws the tick. A checkbox is the desktop idiom\n   for a preference; on a phone an immediate on/off preference is a switch.\n\n   The input stays in the DOM and stays operable — it's moved off-screen\n   rather than display:none, so it keeps its accessible role, its label\n   association and keyboard focus — and .setting-check is redrawn as a\n   track with a sliding thumb.\n\n   Meaning never rests on the colour of the track alone: the thumb position\n   states it, which is legible without colour vision entirely. */\nhtml.m-app .setting-item {\n  align-items: center;\n  gap: var(--m-3);\n  padding: var(--m-3) 0;\n  min-height: 60px;\n  border-bottom: 1px solid var(--m-hairline);\n}\n\nhtml.m-app .settings-options > .setting-item:last-child {\n  border-bottom: none;\n}\n\nhtml.m-app .setting-icon {\n  width: 36px;\n  height: 36px;\n  min-width: 36px;\n  border-radius: var(--m-r-sm);\n  flex: 0 0 auto;\n}\n\nhtml.m-app .setting-icon svg {\n  width: var(--m-icon); height: var(--m-icon);\n}\n\nhtml.m-app .setting-copy {\n  flex: 1 1 auto;\n  gap: 2px;\n}\n\nhtml.m-app .setting-copy strong {\n  font-size: var(--m-fs-body);\n  font-weight: var(--m-fw-medium);\n  line-height: var(--m-lh-snug);\n}\n\nhtml.m-app .setting-copy small {\n  font-size: var(--m-fs-secondary);\n  line-height: var(--m-lh-snug);\n  color: var(--color-text-secondary);\n}\n\nhtml.m-app .setting-item input[type=\"checkbox\"] {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  min-height: 0;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  white-space: nowrap;\n}\n\nhtml.m-app .setting-check {\n  position: relative;\n  flex: 0 0 auto;\n  width: 50px;\n  height: 30px;\n  min-width: 50px;\n  padding: 0;\n  border: none;\n  border-radius: var(--m-r-pill);\n  background: color-mix(in srgb, var(--color-brand-navy) 18%, transparent);\n  transition: background-color var(--m-dur) var(--m-ease);\n}\n\n/* The tick icon inside is redundant once this is a switch. */\nhtml.m-app .setting-check svg { display: none; }\n\nhtml.m-app .setting-check::after {\n  content: '';\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: var(--color-brand-white);\n  box-shadow: 0 1px 3px rgba(1, 13, 33, 0.25);\n  transition: transform var(--m-dur) var(--m-ease);\n}\n\nhtml.m-app .setting-item input:checked + .setting-check {\n  background: var(--color-secondary);\n  border-color: transparent;\n}\n\nhtml.m-app .setting-item input:checked + .setting-check::after {\n  transform: translateX(20px);\n}\n\nhtml.m-app .setting-item input:focus-visible + .setting-check {\n  box-shadow: 0 0 0 3px var(--color-focus-ring);\n}\n\nhtml.m-app[data-theme=\"dark\"] .setting-check {\n  background: rgba(255, 255, 255, 0.22);\n}\n\n/* ── Segmented control ──────────────────────────────────────────────────\n   The theme picker is already a two-up button group, which is the right\n   shape; it just needs mobile measure — and the selected segment needs\n   navy on blue rather than white, which is 3.1:1 and fails AA. */\nhtml.m-app .settings-theme-toggle,\nhtml.m-app .m-segmented {\n  display: grid;\n  grid-auto-flow: column;\n  grid-auto-columns: 1fr;\n  gap: 2px;\n  margin-top: var(--m-3);\n  padding: 3px;\n  border: none;\n  border-radius: var(--m-r-sm);\n  background: var(--m-surface-sunken);\n  overflow: hidden;\n}\n\nhtml.m-app .settings-theme-toggle button,\nhtml.m-app .m-segmented button {\n  min-height: 38px;\n  gap: var(--m-2);\n  border: none;\n  border-radius: calc(var(--m-r-sm) - 3px);\n  background: transparent;\n  color: var(--color-text-secondary);\n  font-size: var(--m-fs-secondary);\n  font-weight: var(--m-fw-medium);\n  transition: background-color var(--m-dur-fast) var(--m-ease),\n              color var(--m-dur-fast) var(--m-ease);\n}\n\nhtml.m-app .settings-theme-toggle button.active,\nhtml.m-app .m-segmented button[aria-selected=\"true\"],\nhtml.m-app .m-segmented button.active {\n  background: var(--m-surface-card);\n  color: var(--color-text-primary);\n  font-weight: var(--m-fw-semibold);\n  box-shadow: var(--m-shadow-sm);\n}\n\nhtml.m-app .settings-theme-toggle button svg,\nhtml.m-app .m-segmented button svg {\n  width: var(--m-icon-sm); height: var(--m-icon-sm);\n}\n\n/* ── Radio / checkbox rows ──────────────────────────────────────────────\n   Where a genuine multi-select or single-choice list exists (delivery\n   options, filters), the whole row is the target, not the 20px control. */\nhtml.m-app .m-choice-row,\nhtml.m-app .sf-checkbox-row {\n  display: flex;\n  align-items: center;\n  gap: var(--m-3);\n  min-height: var(--m-touch);\n  padding: var(--m-2) 0;\n  font-size: var(--m-fs-body);\n  cursor: pointer;\n}\n\nhtml.m-app input[type=\"checkbox\"]:not(.setting-item input),\nhtml.m-app input[type=\"radio\"] {\n  width: 22px;\n  height: 22px;\n  min-height: 22px;\n  min-width: 22px;\n  flex: 0 0 auto;\n  accent-color: var(--color-secondary);\n}\n\n/* ── Quantity stepper ───────────────────────────────────────────────────\n   Three targets in a row, each a full 44px, with a tabular numeral so the\n   width doesn't jump between 9 and 10. */\nhtml.m-app .qty-controls,\nhtml.m-app .m-stepper {\n  display: inline-flex;\n  align-items: center;\n  border: 1px solid var(--m-hairline-strong);\n  border-radius: var(--m-r-sm);\n  overflow: hidden;\n  background: var(--m-surface-card);\n}\n\nhtml.m-app .qty-controls button,\nhtml.m-app .m-stepper button {\n  width: var(--m-touch);\n  height: var(--m-touch);\n  min-width: var(--m-touch);\n  min-height: var(--m-touch);\n  padding: 0;\n  border: none;\n  border-radius: 0;\n  background: transparent;\n  color: var(--color-text-primary);\n  font-size: var(--m-fs-section);\n}\n\nhtml.m-app .qty-controls button:active,\nhtml.m-app .m-stepper button:active {\n  background: var(--color-surface-hover);\n}\n\nhtml.m-app .qty-controls > span,\nhtml.m-app .m-stepper > span {\n  min-width: 40px;\n  text-align: center;\n  font-size: var(--m-fs-body);\n  font-weight: var(--m-fw-semibold);\n  font-variant-numeric: tabular-nums;\n}\n\n/* ── Validation ─────────────────────────────────────────────────────────\n   Error state carries a border, a tinted fill AND a message with an icon —\n   orange alone can't distinguish error from warning in a four-colour\n   system, so the text is what actually says which it is. */\nhtml.m-app .form-group.has-error input,\nhtml.m-app .form-group.has-error select,\nhtml.m-app .form-group.has-error textarea,\nhtml.m-app input[aria-invalid=\"true\"] {\n  border-color: var(--color-primary);\n  background: var(--color-primary-soft);\n}\n\nhtml.m-app .field-error,\nhtml.m-app .form-error {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--m-1);\n  font-size: var(--m-fs-secondary);\n  line-height: var(--m-lh-snug);\n  color: var(--color-text-primary);\n  margin: 0;\n}\n\n/* ── Password visibility toggle ─────────────────────────────────────────── */\nhtml.m-app .pw-toggle,\nhtml.m-app .password-toggle {\n  width: var(--m-touch);\n  height: var(--m-touch);\n  min-width: var(--m-touch);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  background: transparent;\n  color: var(--color-text-muted);\n}\n\n/* ── Cart quantity stepper ──────────────────────────────────────────────\n   .cs-qty-btn is declared 42x38 but renders 23x44: it sits in a flex row\n   (.cs-qty-group) that shrinks it, and 23px wide is well under the point\n   where a thumb hits it reliably -- on the one control where a mis-tap\n   changes what the customer is about to buy.\n\n   Given the same treatment as the other steppers in this layer: a bordered\n   group with square 44px targets that refuse to shrink, and a tabular\n   numeral between them so the width does not jump between 9 and 10. */\nhtml.m-app .cs-qty-group {\n  display: inline-flex;\n  align-items: center;\n  flex: 0 0 auto;\n  border: 1px solid var(--m-hairline-strong);\n  border-radius: var(--m-r-sm);\n  overflow: hidden;\n  background: var(--m-surface-card);\n}\n\nhtml.m-app .cs-qty-btn {\n  flex: 0 0 auto;\n  width: var(--m-touch);\n  height: var(--m-touch);\n  min-width: var(--m-touch);\n  min-height: var(--m-touch);\n  padding: 0;\n  border: none;\n  border-radius: 0;\n  background: transparent;\n  font-size: var(--m-fs-section);\n  color: var(--color-text-primary);\n}\n\nhtml.m-app .cs-qty-btn:active:not(:disabled) {\n  background: var(--color-surface-hover);\n}\n\nhtml.m-app .cs-qty {\n  min-width: 36px;\n  text-align: center;\n  font-size: var(--m-fs-body);\n  font-weight: var(--m-fw-semibold);\n  font-variant-numeric: tabular-nums;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
